import {
  AppstoreOutlined,
  MessageOutlined,
  RocketOutlined,
  SearchOutlined,
  StarOutlined,
} from '@ant-design/icons';
import { Alert, Card } from 'antd';

export const HomePage = () => {
  return (
    <div className="container mx-auto py-8 max-w-3xl">
      <h1 className="text-4xl font-bold mb-8 flex items-center gap-2">
        <span>🍷</span> Wine AI Assistant
      </h1>

      <Alert
        message="Active Development"
        description="This project is in active development. Features may break or change without notice. 🚧"
        type="warning"
        showIcon
        className="mb-8"
      />

      <Card
        title={
          <div className="flex items-center gap-2">
            <MessageOutlined className="text-lg" />
            Important Notes <span>📝</span>
          </div>
        }
        className="mb-8"
      >
        <div className="space-y-4">
          <p>
            The chat function currently treats each message independently.
            Previous chat context is not sent to the AI, so each message is
            processed as a new conversation. This means the AI cannot reference
            or remember previous messages in your conversation.
          </p>
          <p className="flex items-center gap-2">
            <RocketOutlined className="text-lg" />
            We are continuously working on improving the experience and adding
            new features. Thank you for your understanding and patience.{' '}
            <span>✨</span>
          </p>
        </div>
      </Card>

      <Card
        title={
          <div className="flex items-center gap-2">
            <StarOutlined className="text-lg" />
            Features <span>🎯</span>
          </div>
        }
      >
        <ul className="space-y-3">
          <li className="flex items-center gap-2">
            <SearchOutlined className="text-lg" />
            AI-powered wine recommendations 🤖
          </li>
          <li className="flex items-center gap-2">
            <AppstoreOutlined className="text-lg" />
            Wine information lookup 🔍
          </li>
          <li className="flex items-center gap-2">
            <MessageOutlined className="text-lg" />
            Chat interface for wine-related questions 💬
          </li>
          <li className="flex items-center gap-2">
            <StarOutlined className="text-lg" />
            Comprehensive wine database 📚
          </li>
        </ul>
      </Card>
    </div>
  );
};
